<lx-price-lists-portal-table-header title="Transfer service fees" [currency]="currency"></lx-price-lists-portal-table-header>
<p-table [value]="transfers">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + company | lowercase">
      <th>Destination</th>
      <th>Collective</th>
      <th>Private</th>
      <th class="nowrap">UM Service *</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-transfer>
    <tr>
      <td>{{ transfer.name }}</td>
      <td>{{ transfer.collectivePrice | lxPrice : { defaultValue: '-' } }}</td>
      <td>{{ transfer.privatePrice | lxPrice : { defaultValue: '-' } }}</td>
      <td>{{ transfer.umPrice | lxPrice : { defaultValue: '-' } }}</td>
    </tr>
  </ng-template>
</p-table>
<lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
